import { el } from './el';

export function t(): typeof el {
  return el;
}
